import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import ReactGA from "react-ga4";


import { GlobalLoader, RotateDevice, Features, GameLaunch, Notification, MaintenanceNotify } from './global';
import { GOOGLE_ANALYTICS_ID, PascalPenaltyGameId } from '../constants';
import PauseGame from './global/features/pause-game';
import { Splash, Modals } from './containers';
import { LaunchData } from '../models';
import { env } from '../environment';
import { useStore } from '../hooks';

interface AppProps {

}

export const App: React.FC<AppProps> = observer(() => {

  const { gameStore, loaderStore, postMessageStore, maintenanceStore } = useStore();
  const { gameLoaded } = loaderStore;
  const { gamePaused, gameId, launchData: { data } } = gameStore;
  // nothing pauses a game that the maintenance page already replaced
  const showPauseGame = gamePaused && !maintenanceStore.isMaintenanceMode;
  const showRotateDevice = gameId !== PascalPenaltyGameId;

  useEffect(() => {
    window.addEventListener('message', (event) => {
      postMessageStore.handleMessageReceive(event.data, event.source);
    });
  }, []);

  useEffect(() => {
    if (data && env.production) {
      initGoogleAnalytics(data);
    }
  }, [data]);

  const initGoogleAnalytics = useCallback((data: LaunchData) => {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID);
    const { gameId, currency, partnerId } = data;
    ReactGA.send({ 
      gameId,
      currency,
      partnerId,
      domain: window.location.hostname
    });
  }, []);

  const content = useMemo(() => {
    return (
      <>
        {
          !gameLoaded && (
            <GlobalLoader />
          )
        }
        {
          showPauseGame && (
            <PauseGame />
          )
        }
        <GameLaunch />
        {showRotateDevice && <RotateDevice />}
        <Modals />
        <Notification />
        <MaintenanceNotify />
        <Features />
      </>
    );
  }, [showPauseGame, gameLoaded, showRotateDevice]);

  return (
    <Splash>
      {content}
    </Splash>
  );
});
